/**
 * Soundium — FX-aware static money amounts (SND-10931).
 *
 * Theme copy sometimes states fixed money figures that the storefront cannot
 * convert on its own — e.g. "Free delivery over €149", "Shipping from €4",
 * the header "Free EU shipping over €149". Product prices auto-convert through
 * Shopify Markets, but a literal €149 baked into a sentence stays in euros and
 * looks wrong to a shopper paying in kr / zł.
 *
 * This rewrites any element carrying `data-snd-fx="<eur-amount>"` into the
 * visitor's active presentment currency using Shopify's live market rate,
 * rounded to a clean figure with no decimals (per Vincas, SND-10931 #1).
 *
 * The element's existing text is the EUR baseline and stays untouched on euro
 * markets and when JS is unavailable, so nothing regresses for the €-markets.
 *
 *   <span data-snd-fx="149">€149</span>   → SE: "1 650 kr", PL: "640 zł", …
 *
 * Optional attributes:
 *   data-snd-fx-base="EUR"   currency the figure is written in (default EUR = shop base)
 *   data-snd-fx-round="1"    force a rounding step instead of the auto "nice" step
 */
(function () {
  var BASE_DEFAULT = 'EUR';

  function niceRound(v, step) {
    if (step && step > 0) return Math.round(v / step) * step;
    // Auto "nice" step scaled to magnitude — keeps figures clean, never shows cents.
    if (v < 20) return Math.round(v);
    if (v < 100) return Math.round(v / 5) * 5;
    if (v < 1000) return Math.round(v / 10) * 10;
    if (v < 10000) return Math.round(v / 50) * 50;
    return Math.round(v / 100) * 100;
  }

  function formatter(currency, locale) {
    var tries = [
      { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0, minimumFractionDigits: 0 },
      { style: 'currency', currency: currency, maximumFractionDigits: 0, minimumFractionDigits: 0 }
    ];
    for (var i = 0; i < tries.length; i++) {
      try { return new Intl.NumberFormat(locale, tries[i]); } catch (e) {}
    }
    return null;
  }

  function run() {
    var C = window.Shopify && window.Shopify.currency;
    if (!C) return;
    var active = String(C.active || '').toUpperCase();
    var rate = parseFloat(C.rate || '1');
    if (!active || !isFinite(rate) || rate <= 0) return;

    var locale = (document.documentElement.getAttribute('lang') || 'en').trim() || 'en';
    var fmtCache = {};

    var nodes = document.querySelectorAll('[data-snd-fx]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var base = parseFloat(el.getAttribute('data-snd-fx'));
      if (isNaN(base)) continue;
      var baseCur = (el.getAttribute('data-snd-fx-base') || BASE_DEFAULT).toUpperCase();

      // Same currency as the figure is written in → leave the euro baseline alone.
      if (active === baseCur) { el.removeAttribute('data-snd-fx-done'); continue; }
      if (el.getAttribute('data-snd-fx-done') === active) continue;

      var step = parseFloat(el.getAttribute('data-snd-fx-round')) || 0;
      var local = niceRound(base * rate, step);

      var fmt = fmtCache[active] || (fmtCache[active] = formatter(active, locale));
      var out = fmt ? fmt.format(local) : (local.toLocaleString(locale) + ' ' + active);

      el.textContent = out;
      el.setAttribute('data-snd-fx-done', active);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Theme editor / Section Rendering API re-renders.
  document.addEventListener('shopify:section:load', run);
  // Cart/localization changes can swap currency without a full reload.
  document.addEventListener('shopify:block:select', run);
})();
